import { render, staticRenderFns } from "./campaignsList.vue?vue&type=template&id=e74b2f1a"
import script from "./campaignsList.vue?vue&type=script&lang=js"
export * from "./campaignsList.vue?vue&type=script&lang=js"
import style0 from "./campaignsList.vue?vue&type=style&index=0&id=e74b2f1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports